import React from 'react';

const permissionsData = [
  {
    title: 'There are no inactive users in your account',
    description:
      'Keeping inactive users to a minimum ensures that your account is only accessed by current users.',
    showButton: true,
  },
  {
    title: '1 user is not enrolled in two-factor authentication (2FA)',
    description:
      'Remind users to enable 2FA to help protect your account from unauthorized access.',
    showButton: true,
  },
  {
    title: 'There are no users with critical permissions',
    description:
      'Limit high-risk permissions to fewer users to keep your account more secure.',
    showButton: false,
  },
  {
    title: 'There is only 1 Super Admin in your account',
    description:
      'Limiting admins to fewer than 1 helps prevent unnecessary distribution of permissions and enables effective task performance.',
    showButton: true,
  },
  {
    title: 'There are no partner users with Super Admin access',
    description:
      "Minimizing the number of partners with Super Admin access boosts your account's data security and reduces access risk.",
    showButton: false,
  },
];

// Renders a component displaying user permission statuses with management options
const Permissions: React.FC = () => {
  return (
    <div>
      {/* Tabs */}
      <div>
        {/* Description */}
        <div className='text-[#657584] text-[16px] mb-6'>
          Keep your account secure by monitoring and managing user permissions.
          Check important settings like Super Admin roles, two-factor
          authentication, inactive users, and partner access to minimize risks.
        </div>

        {/* Cards */}
        <div className='flex flex-col gap-4 py-6 px-0 pt-0'>
          {permissionsData.map((item, idx) => (
            <div
              key={idx}
              className='bg-[#F5F8FA] rounded-lg p-4 flex justify-between items-center'
            >
              <div>
                <h3 className='font-semibold text-[#3F5265] text-[18px] mb-1'>
                  {item.title}
                </h3>
                <p className='text-[#657584] text-[16px]'>{item.description}</p>
              </div>
              {item.showButton && (
                <button className='px-4 py-2 text-[14px] font-semibold text-[#00899E] border border-[#00899E] rounded hover:bg-[#F0F9FB]'>
                  Manage
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Permissions;
